export default function formatCpfCnpj(value?: string): string {
  if (!value) return '';

  const cleanValue = value
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');

  const isCnpj = /[A-Z]/.test(cleanValue) || cleanValue.length > 11;

  if (!isCnpj) {
    const cpf = cleanValue.replace(/\D/g, '').slice(0, 11);

    if (cpf.length <= 3) return cpf;
    if (cpf.length <= 6) return `${cpf.slice(0, 3)}.${cpf.slice(3)}`;
    if (cpf.length <= 9) return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6)}`;

    return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(9, 11)}`;
  }

  const cnpj = cleanValue.slice(0, 14);

  const root = cnpj.slice(0, 8);
  const order = cnpj.slice(8, 12);
  const digit = cnpj.slice(12, 14);

  const rootPart1 = root.slice(0, 2);
  const rootPart2 = root.slice(2, 5);
  const rootPart3 = root.slice(5, 8);

  let formattedRoot = rootPart1;

  if (root.length > 2) {
    formattedRoot += `.${rootPart2}`;
  }

  if (root.length > 5) {
    formattedRoot += `.${rootPart3}`;
  }

  if (cnpj.length <= 8) {
    return formattedRoot;
  }

  if (cnpj.length <= 12) {
    return `${formattedRoot}/${order}`;
  }

  return `${formattedRoot}/${order}-${digit}`;
}